import {Space} from "antd";
import {useFormContext} from "react-hook-form";
import {IS_PWYW_ENABLED} from "../../../../../services/config";
import {PricingModelCardsFormField} from "../../../general/pricing/pricing-model-cards";
import {PwywCurrenciesFormField} from "../../../general/pricing/pwyw-currencies";
import {SessionCurrenciesFormField} from "./currencies";
import {SessionPricingFormFieldsType} from "./types";

/**
 * The booking service's Pricing section, shared with the Session Bundle.
 *
 * Same shape as the live event's, and for the same reasons — see
 * `LiveEventPricingFormFields`. A bundle is priced as a whole pack but is a booking
 * service on the wire, so it renders this section unchanged apart from its field id.
 *
 * @param currenciesFieldId - the id of the Single Fee currency rows' field
 */
export function SessionPricingFormFields({
  currenciesFieldId = "sessionPrice",
}: {
  currenciesFieldId?: string;
}) {
  const {watch} = useFormContext<SessionPricingFormFieldsType>();
  const isPayWhatYouWant = IS_PWYW_ENABLED && watch("callPriceType") === "pwyw";

  return (
    <Space size={16} direction="vertical" style={{display: "flex"}}>
      <PricingModelCardsFormField priceTypeField="callPriceType" baseCurrencyInScalars />
      {isPayWhatYouWant ? (
        <PwywCurrenciesFormField />
      ) : (
        <SessionCurrenciesFormField
          id={currenciesFieldId}
          label="Other price"
          placeholder="100"
        />
      )}
    </Space>
  );
}
